import React from 'react'
import { useTheme } from '@mui/material'
import BackButton from 'redesign/components/atoms/Buttons/BackButton'
import CloseButton from 'redesign/components/atoms/Buttons/CloseButton/CloseButton'
import LoadingSpinner from 'redesign/components/atoms/LoadingSpinner'
import FooterWrapper from 'redesign/components/atoms/footer-wrapper'
import HeaderLabel from 'redesign/components/molecules/HeaderLabel'
import { DrawerHeaderWrapper } from 'redesign/components/molecules/drawer-header-wrapper'
import Header from 'redesign/components/organisms/Header'
import ActionButtons from 'redesign/components/organisms/action-buttons'
import BalanceModal from 'redesign/components/organisms/modals/balance-modal'
import { useActionButtons } from 'redesign/pages/new-absence-request/hooks/use-action-buttons'
import { SIDE_MENU_OPTIONS, SIDE_MENU_TRANSLATIONS } from '../../SideMenu/constants'
import type { MenuPageProps } from '../../SideMenu/types'
import NewAbsenceRequestContent from '../../new-absence-request-content'
import { Body } from './styles'
import { useSideMenuNewAbsenceRequest } from './use-side-menu-new-absence-request'

const SideMenuNewAbsenceRequest: React.FC<MenuPageProps> = ({ onClose, setPage, isDrawer = false, t, onRefresh }) => {
  const { palette } = useTheme()
  const props = useSideMenuNewAbsenceRequest({ setPage, onRefresh })
  const {
    loadingMutation,
    loading,
    onSubmit,
    setIsBalanceDrawerOpen,
    isBalancesDrawerOpen,
    formFields: {
      personUuid: { value: personUuid },
    },
  } = props

  const loadingContent = loadingMutation || loading
  const actionButtons = useActionButtons({
    onSubmit,
    setIsBalanceDrawerOpen,
    balanceDisabled: !personUuid,
  })

  return (
    <DrawerHeaderWrapper
      header={
        <Header
          startContent={isDrawer && <BackButton onGoBack={() => setPage(SIDE_MENU_OPTIONS.mainMenu)} />}
          middleContent={<HeaderLabel mainText={t(SIDE_MENU_TRANSLATIONS[SIDE_MENU_OPTIONS.newAbsenceRequest])} />}
          endContent={isDrawer && <CloseButton onClick={onClose} />}
        />
      }
      footer={
        <FooterWrapper>
          <ActionButtons {...actionButtons} />
        </FooterWrapper>
      }
      backgroundColor={palette.background.base}
    >
      <Body>
        {loadingContent ? <LoadingSpinner /> : <NewAbsenceRequestContent {...props} />}
        <BalanceModal
          selectedPersonUuid={personUuid as string}
          open={isBalancesDrawerOpen}
          onClose={() => setIsBalanceDrawerOpen(false)}
        />
      </Body>
    </DrawerHeaderWrapper>
  )
}

export default SideMenuNewAbsenceRequest
